import React from 'react'
import { FlexRow, Text } from 'elements'

type StyleProps = {
  color?: string
  backgroundColor?: string
  borderRadius?: string
  height?: string
  includePercent?: boolean
  border?: string
}

type Props = {
  progress: number
  styleProps?: StyleProps
}

export default function ProgressBar(props: Props) {
  const { progress, styleProps } = props

  return (
    <FlexRow
      border={styleProps?.border}
      bg={styleProps?.backgroundColor}
      borderRadius={styleProps?.borderRadius || 'xxsmall'}
      style={{ overflow: 'hidden' }}
      borderColor="neutral.2"
      width="100%"
      alignItems="center"
    >
      <FlexRow
        height={styleProps?.height || 'xxxlarge'}
        bg={styleProps?.color || 'secondary.0'}
        width={`${progress}%`}
        justifyContent="center"
        alignItems="center"
        mr={progress <= 15 ? 'small' : null}
      >
        {progress > 15 && styleProps?.includePercent && (
          <Text color="background.0" fontWeight="bold">{`${progress}%`}</Text>
        )}
      </FlexRow>
      {progress <= 15 && styleProps?.includePercent && (
        <Text fontWeight="bold">{`${progress}%`}</Text>
      )}
    </FlexRow>
  )
}
